import { useCallback } from "react";

import FlashContext from "components/FlashMessages/FlashContext";

import useTypedContext from "./useTypedContext";

const useLazyCopyToClipboard = () => {
  const { reportSuccess, reportError } = useTypedContext(FlashContext);

  return useCallback(
    async (text: string) => {
      try {
        await navigator.clipboard.writeText(text);
        reportSuccess({ message: "Copied to clipboard" });
        return true;
      } catch {
        reportError({ message: "Could not copy to clipboard" });
        return false;
      }
    },
    [reportSuccess, reportError]
  );
};

export default useLazyCopyToClipboard;
